$(() => {
  const total_no_of_practitioners = () => {
    return parseInt($('#total-no-of-practitioners').val().replaceAll(',', ''));
  };

  const practitioners_for_initial_credential = () => {
    return parseInt($('#practitioners-for-initial-credential').val().replaceAll(',', ''));
  };

  const practitioners_for_recredential = () => {
    return parseInt($('#practitioners-for-recredential').val().replaceAll(',', ''));
  };

  const practitioners_for_enrollment = () => {
    return parseInt($('#practitioners-for-enrollment').val().replaceAll(',', ''));
  };

  const total_fte = () => {
    return parseInt($('#total-fte').val().replaceAll(',', ''));
  };

  const total_fte_calculated = () => {
    if (total_no_of_practitioners() <= 2000) {
      return Math.ceil(total_no_of_practitioners() / 150);
    } else if (total_no_of_practitioners() <= 4000) {
      return Math.ceil(total_no_of_practitioners() / 200);
    } else {
      return Math.ceil(total_no_of_practitioners() / 250);
    }
  };

  const fte_doing_credentialing = () => {
    // =ROUNDUP(0.25*J13,0)
    return Math.ceil(0.25 * total_fte());
  };

  const fte_doing_enrolling = () => {
    // =ROUNDUP(0.7*J13,0)
    return Math.ceil(0.7 * total_fte());
  };

  const fte_doing_recredentialing = () => {
    // =ROUNDUP(0.05*J13,0)
    return Math.ceil(0.05 * total_fte());
  };

  const psv_license_fee = () => {
    // =IF(N18=TRUE,((Q34*G20)+(R34*G22)),0)
    return 140 * practitioners_for_initial_credential() + 140 * practitioners_for_recredential();
  };

  const pes_license_fee = () => {
    // =IF(N25=TRUE,R42,0)
    // R42; =IF(AND(G14>=T34,G14<=U34),V34*G27,IF(AND(G14>=T35,G14<=U35),V35*G27,IF(AND(G14>=T36,G14<=U36),V36*G27,IF(G14>=T37,V37*G27))))
    let enrollment_cost = 900;

    if (total_no_of_practitioners() <= 49) {
      enrollment_cost = 1200;
    } else if (total_no_of_practitioners() <= 499) {
      enrollment_cost = 1100;
    } else if (total_no_of_practitioners() <= 899) {
      enrollment_cost = 1000;
    }

    return practitioners_for_enrollment() * enrollment_cost;
  };

  const run = () => {
    if ($('#fte-doing-credentialing-overridden').val() === '0') {
      $('#fte-doing-credentialing').val(fte_doing_credentialing());
    }

    if ($('#fte-doing-enrolling-overridden').val() === '0') {
      $('#fte-doing-enrolling').val(fte_doing_enrolling());
    }

    if ($('#fte-doing-recredentialing-overridden').val() === '0') {
      $('#fte-doing-recredentialing').val(fte_doing_recredentialing());
    }

    if ($('#psv-license-fee-overridden').val() === '0') {
      $('#psv-license-fee').val(accounting.formatMoney(psv_license_fee(), '', 0));
    }

    if ($('#pes-license-fee-overridden').val() === '0') {
      $('#pes-license-fee').val(accounting.formatMoney(pes_license_fee(), '', 0));
    }
  };

  $('#total-fte').blur(() => {
    $('#total-fte-overridden').val('1');
  });

  $('#fte-doing-credentialing').blur(() => {
    $('#fte-doing-credentialing-overridden').val('1');
  });

  $('#fte-doing-enrolling').blur(() => {
    $('#fte-doing-enrolling-overridden').val('1');
  });

  $('#fte-doing-recredentialing').blur(() => {
    $('#fte-doing-recredentialing-overridden').val('1');
  });

  $('#psv-license-fee').blur(() => {
    $('#psv-license-fee-overridden').val('1');
  });

  $('#pes-license-fee').blur(() => {
    $('#pes-license-fee-overridden').val('1');
  });

  // We need to handle changes to total-no-of-practitioners separately because total-fte
  // is also a calculated but editable field. If we just call `run` for everything, the
  // recalculation can fire before we register that total-fte was changed and we end up
  // overwriting the total-fte value the user entered with the calculated value.
  $('#total-no-of-practitioners').change(() => {
    if ($('#total-fte-overridden').val() === '0') {
      $('#total-fte').val(total_fte_calculated());
    }

    run();
  });

  $('#total-fte, #practitioners-for-initial-credential, #practitioners-for-recredential, #practitioners-for-enrollment').change(() => {
    run();
  });
});
